import { motion } from "framer-motion";
import {
    Search,
    Home,
    Compass,
    Tag,
    User,
    Scale,
    Tags,
    Zap,
    Plane,
    BedDouble,
    Sparkles,
} from "lucide-react";

const FEATURE_TILES = [
    { icon: Scale, label: "Compare" },
    { icon: Tags, label: "Coupons" },
    { icon: Zap, label: "Quick" },
    { icon: Plane, label: "Flights" },
    { icon: BedDouble, label: "Hotels" },
    { icon: Sparkles, label: "AI Search" },
];

const PhoneMockup = () => (
    <motion.div
        data-testid="hero-phone-mockup"
        animate={{ y: [0, -12, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        className="relative mx-auto w-[280px] sm:w-[310px]"
    >
        <div className="rounded-[2.8rem] border border-cream/15 bg-[#111a16] p-2.5 shadow-[0_40px_90px_-20px_rgba(0,0,0,0.7)]">
            <div className="relative overflow-hidden rounded-[2.2rem] bg-cream">
                <div className="absolute left-1/2 top-2.5 h-5 w-24 -translate-x-1/2 rounded-full bg-ink" />
                <div className="px-5 pb-6 pt-12">
                    <div className="flex items-center gap-2">
                        <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-ink">
                            <span className="h-3 w-3 rounded-full border-2 border-saffron" />
                        </span>
                        <span className="font-display text-lg font-semibold tracking-tight text-ink">
                            Sahi<span className="text-saffron">Khoj</span>
                        </span>
                    </div>
                    <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-smoke">
                        Sahi Khoj. Sahi Daam.
                    </p>
                    <div className="mt-5 flex items-center gap-2.5 rounded-full border border-ink/10 bg-white px-4 py-3">
                        <Search className="h-4 w-4 text-saffron" />
                        <span className="text-xs text-smoke">
                            Search in the app…
                        </span>
                    </div>
                    <div className="mt-5 grid grid-cols-2 gap-2.5">
                        {FEATURE_TILES.map(({ icon: Icon, label }) => (
                            <div
                                key={label}
                                className="flex items-center gap-2 rounded-2xl border border-ink/5 bg-white px-3 py-3"
                            >
                                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-saffron-soft">
                                    <Icon className="h-3.5 w-3.5 text-saffron" />
                                </span>
                                <span className="text-[11px] font-medium text-ink">
                                    {label}
                                </span>
                            </div>
                        ))}
                    </div>
                    <div className="mt-5 h-2 w-3/4 rounded-full bg-india/10" />
                    <div className="mt-2 h-2 w-1/2 rounded-full bg-saffron/20" />
                </div>
                <div className="flex items-center justify-around border-t border-ink/5 bg-white px-6 py-3.5">
                    <Home className="h-4 w-4 text-saffron" />
                    <Compass className="h-4 w-4 text-smoke/50" />
                    <Tag className="h-4 w-4 text-smoke/50" />
                    <User className="h-4 w-4 text-smoke/50" />
                </div>
            </div>
        </div>
    </motion.div>
);

export default PhoneMockup;
